import { version } from "../package.json"

export default {
  fbUMpvnf: "7x!A%C*F-JaNdRgUkXp2s5v8y/B?E(G+",
  appTitle: process.env.VUE_APP_TITLE,
  appVersion: version,
  baseUrl: process.env.VUE_APP_BASE_URL,
  UPLOAD_URL: process.env.VUE_APP_UPLOAD,
  IMAGE_URL: process.env.VUE_APP_IMAGE,

  userBaseUrl: "/6YWYPBKrUG",
  accessRoles: {
    account: "account",
    accountapi: "accountapi",
    accountoverview: "accountoverview",
    bank: "bank",
    function: "function",
    iplist: "iplist",
    log: "log",
    overview: "overview",
    page: "page",
    report: "report",
    role: "role",
    setting: "setting",
    ticket: "ticket",
    user: "user"
  },
  useConfigUrl: process.env.VUE_APP_STATIC_URL == "true",
  LIMIT: {
    MIN: 1,
    MAX: 999999999,
    MPM: 9999999999,
    PACKAGES: ["A", "B", "C", "D", "E", "F"]
  },
  intMaxValue: 2000000000,

  getDomain(url, subdomain) {
    subdomain = subdomain || false;

    url = url.replace(/(https?:\/\/)?(www.)?/i, "");

    if (!subdomain) {
      url = url.split(".");

      url = url.slice(url.length - 2).join(".");
    }

    if (url.indexOf("/") !== -1) {
      return url.split("/")[0];
    }

    return url;
  },
  getBaseUrl() {
    if (this.useConfigUrl) {
      return this.baseUrl;
    }
    var domain = this.getDomain(window.location.hostname, false);
    if (domain != "localhost") {
      return "https://api." + domain;
    } else {
      return this.baseUrl;
    }
  },
  secureloginUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/securelogin";
  },
  functionListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getfunctionlist";
  },
  addFunctionUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/addfunction";
  },
  editFunctionUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/editfunctioninfo";
  },
  deleteFunctionUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/deletefunction";
  },
  pageListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpagelist";
  },
  addPageUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/addpage";
  },
  editPageUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/editpageinfo";
  },
  deletePageUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/deletepage";
  },
  roleListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getrolelist";
  },
  addRoleUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/addrole";
  },
  editRoleUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/editroleinfo";
  },
  deleteRoleUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/deleterole";
  },
  userListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getuserlist";
  },
  editUserStatusUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/userstatusupdate";
  },
  addUserUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/createuser";
  },
  editUserUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/updateuser";
  },
  resetPwdUserUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/userpasswordreset";
  },
  getUserRoleUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getuserrole";
  },
  addUserRoleUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/useraddroles";
  },
  pageFunctionListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpagefunctionlist";
  },
  pageRoleListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getpagerolelist";
  },
  editPageFunctionUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/upsertpagefunction";
  },
  editPageRoleUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/upsertpagerole";
  },
  changePwdUserUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/userchangepassword";
  },
  ipListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/getiplist";
  },
  insertIPUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/insertip";
  },
  deleteIPUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/deleteip";
  }
};
